import React from "react";
import "./homeSections.css";

const HowItWorks = () => {
  return (
    <section className="home-section how-section">
      <div className="container">

        <h2>How ShareVideo Works</h2>

        <p>
          ShareVideo is built to make content publishing simple and accessible.
          Whether you are a video creator, musician, or visual storyteller,
          our platform allows you to upload and share content in multiple
          formats with ease.
        </p>

        <div className="how-step">
          <h3>1. Create an Account</h3>
          <p>
            Sign up for a free account and access your personal creator
            dashboard. Your dashboard allows you to manage uploads,
            track performance, and edit your profile.
          </p>
        </div>

        <div className="how-step">
          <h3>2. Upload Your Content</h3>
          <p>
            Upload full-length videos, short vertical clips (Shorts),
            music videos, standalone audio songs, or photo posts.
            Our platform supports multiple content formats so you
            can share your creativity without limitations.
          </p>
        </div>

        <div className="how-step">
          <h3>3. Content Discovery</h3>
          <p>
            Once published, your content becomes discoverable through
            the homepage, category sections, and recommendation feeds.
            Viewers can watch, listen, and engage with your content,
            helping you grow your audience organically.
          </p>
        </div>

        <div className="how-step">
          <h3>4. Earn Through Impressions</h3>
          <p>
            ShareVideo operates on an impression-based earning model.
            Creators can generate revenue based on the visibility
            and engagement their content receives. High-quality and
            original content performs better within our ecosystem.
          </p>
        </div>

        <div className="how-step">
          <h3>5. Community & Safety</h3>
          <p>
            We promote a safe and responsible content environment.
            All uploads must follow our community guidelines,
            copyright policies, and platform standards to ensure
            a positive experience for everyone.
          </p>
        </div>

      </div>
    </section>
  );
};

export default HowItWorks;